export default __webpack_public_path__ + "static/media/logo-blue-iranair.eb2e0d57.png";